import React from 'react';
import { useState, useEffect } from 'react';
import './dropdown.css'
import '../../App.css'
import '../../screens/reservation.css'
import DropArrowSvg from '../../svgs/reservation/dropArrowSvg'
const DropdownFilter = ({data, placeholder, cb, value}) => {
    //
    // if(!heading || !dropDownObj) return<></>
    return (
        <div className='flex flex-col items-start justify-start gap-[8px] w-full bg-white'>
            <div className='flex flex-col items-start justify-center gap-[8px] w-full filter_1 relative'>
                <div className='w-full flex flex-row items-center justify-between border-[1px] px-[8px]'>
                    <div className='select-none cursor-pointer w-full h-[28px] text-black flex items-center text-d-10 font-[600] text-[#e2e2e2] twok-size'>{ value ||placeholder}</div>
                    <DropArrowSvg />
                </div>
                <div className='w-full infobox_1'>
                    <div className='w-full flex flex-col items-start justify-start max-h-[30vh] overflow-y-scroll rightside_border_color border-t-[1px] mt-[2px] border border-[1px]' style={{zIndex:9999}}>
                        {data.map((val, i ) => (
                            <div onClick={() => cb(val)} key={val+i} className='select-none cursor-pointer hover:font-bold bg-white hover:bg-[#0FBAB5] hover:text-white w-full px-[8px] py-[6px] flex flex-row items-center h-[21px] text-d-10 twok-size' style={{}}>{val}</div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DropdownFilter;